import Base from 'app/views/base';

import { trimMoney } from 'utils/strings';
import tmpl from 'templates/account_balance';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click #one_time_charge button': 'showChargeModal',
  },

  initialize() {
    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    const str = (parseFloat(this.model.get('price_per_shipment')) * 100).toFixed(1);
    const cents = str.split('.')[0];
    const subcents = str.split('.')[1];
    const out = cents + (subcents === '0' ? '' : `.${subcents}`);

    return {
      balance: trimMoney(this.model.get('balance'), 'USD'),
      price_per_shipment: out,
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/account_balance_view.js